export const environment = {
  production: true,
  envName: 'ci'
};
